import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';

export const llmList = [
    {
        id: 1,
        name: "Mistral Nemo",
        description: "Recommended: A fast lightweight model that maintains accuracy and robustness.",
        icon: <BalanceOutlinedIcon fontSize="medium" />
    },
    {
        id: 2,
        name: "Llama 3.2",
        description: "A very fast model provided but prone to inaccuracies.",
        icon: <BoltOutlinedIcon fontSize="medium" />
    },
    {
        id: 3,
        name: "Gemma 3",
        description: "A deep thinking robust model tailored for accuracy",
        icon: <LightbulbOutlinedIcon fontSize="medium" />
    },
    {
        id: 4,
        name: "DeepSeek R1",
        description: "A very robust and deep thinking model, that outputs its thoughts.",
        icon: <PsychologyOutlinedIcon fontSize="medium" />
    }
];